/// <reference path="../../jquery/jquery.d.ts" />

interface UserResponse {
    tokenID  : string,
    userbase : string,
    webID    : number
}

interface CreditResponse {
    result     : string,
    credit     : number,
    inCurrency : number,
    topups     : number,
    reg_date   : string,
    query      : string,
    spECP      : boolean
}

interface SexChatResponse {
    error       : boolean|string,
    info        : boolean|string,
    showCaptcha : boolean,
    stat        : any,
    visible     : boolean
}

class BabesHandler {

    private translateJSON : any = {};

    constructor() {
        if(window.location.href.indexOf("/babes") !== -1) {
            window.history.replaceState("", "", '/live');
        }
    }

    init() : Promise<void> {
        return new Promise((resolve, reject) => {
            this.getLanguageJSON()
                .then(() => {
                    this._bindShortKey();
                    this._bindDOMEvent();

                    this._settings_menuHandler();
                    this._popup_fixcontentsHandler();

                    this.setuphappyhour();
                    this.setupchatloaded();
                    this.setupTopupZeroPopup();
                })
                .then(resolve, reject);
        });
    }

    /**
     * Happy hour megjelenítése és frissítése
     */
    setuphappyhour(){
        //window["echh"] = new EcHappyHour(); //Régi design módszer
        let thisref=this;
        //$(window).load(function () {thisref._checkHappyHourPromo();});
        setInterval(() => { this._checkHappyHourPromo(); }, 15000);
    }

    /**
     * Chat betöltése utáni műveletek
     */
    setupchatloaded(){
        this._checkTopupBalance();
        setInterval(() => { this._checkTopupBalance(); }, 30000);
        let thisref=this;
        $(window).load(function () {
            let waiter = setInterval(function() {
                // @ts-ignore
                if ( typeof chatClient !== 'undefined') {
                    thisref._checkTopupBalance();
                    clearInterval(waiter);
                }
            }, 300);
            // @ts-ignore
            if(__isLoggedMember){
                let waiter2 = setInterval(function() {
                    if ($(".sxcc-topup-panel .sxcct-picker").length>0) {
                        clearInterval(waiter2);
                        thisref._checkTopupBalance();
                    }
                }, 300);
                let waiter3 = setInterval(function() {
                    if ($(".topup-button").length>0) {
                        clearInterval(waiter3);
                        $("#topupmenu,#creditadd_menuitem").show();
                        thisref._checkTopupBalance();

                        //Wheelpromo turn on
                        // @ts-ignore
                        window.wheelPromoHandler = new WheelPromo();
                    }
                }, 300);
            }
        });

        //Fancybox bug javítása régebbi jQuery verzió miatt
        jQuery.fn.addBack = jQuery.fn.andSelf;
    }

    /**
     * 1 hét utáni 0 kredit és 0 feltöltés esetén popup ok megjelenítése időnként
     */
    private activitychecker=0;
    public activitychecker_random=100;
    showZeroTopupPopupIfNecessary(){
        if(this.topups==0 && this.current_credits==0 //&& ( Math.abs(new Date().getTime() - new Date(Date.parse(this.reg_date)).getTime()) / (60*60*1000)) > 24*7
            && this.activitychecker>this.activitychecker_random && !$(".sxcc-topup-panel").is(":visible")){
            window["chatClient"].app.view.topupPanel.needFirstZeroCredit=true;
            window["chatClient"].app.view.topupPanel.needFirstCredit=true;
            window["chatClient"].app.view.topupPanel.show(true);
            this.activitychecker=0;
            window["cookie"].erase("activitychecker");
            window["cookie"].create("activitychecker", this.activitychecker);
            this.activitychecker_random=this.GetRand(40,80);
        }
    }
    setupTopupZeroPopup(){
        let thisref=this;
        thisref.activitychecker_random=this.GetRand(40,80);
        let cookieval=window["cookie"].read("activitychecker");
        if(typeof cookieval !== undefined && cookieval!=null && cookieval.length>0){
            this.activitychecker=parseInt(cookieval);
        }
        setTimeout(function () {
            $(".sxcc-stream-wrapper,.sxcc-chat,.sxcc-sampler,.sxcc-special-gift-panel").mousedown(function () { thisref.activitycheckeradd();  });
            $('.sxcc-chat-form-input,.performercontent .mediagallery').keydown(function (e){
                if(e.keyCode == 13){  thisref.activitycheckeradd(); }
            })
        },5000);
    }
    activitycheckeradd(){
        let thisref=this;
        if(thisref.topups==0 && thisref.current_credits==0 //&& ( Math.abs(new Date().getTime() - new Date(Date.parse(thisref.reg_date)).getTime()) / (60*60*1000)) > 24*7
            && !$(".sxcc-topup-panel").is(":visible")
        ){
            thisref.activitychecker++;
            window["cookie"].erase("activitychecker");
            window["cookie"].create("activitychecker", thisref.activitychecker);
            //console.log("activitychecker:"+thisref.activitychecker+" / "+thisref.activitychecker_random);
            thisref.showZeroTopupPopupIfNecessary();
        }
    }

    /**
     * Random integer
     */
    GetRand(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive
    }


    /**
     * Szöveges tartalmak felugró ablakban - kezelés
     */
    _popup_fixcontentsHandler() {
        let thisref=this;
        $(document).ready(function() {
            //fixcontents open in popup form url
            let urlelements = window.location.href.replace(/\/$/, "").replace(/\#(.*)$/, "").split("/");
            let location = "";
            if (urlelements.length >= 1) {
                location = urlelements[urlelements.length - 1];
            }
            if (location != "") {
                if ( ["terms", "privacy", "voxebankinfo", "happyhourrules", "2257", "btk222","billingsupport","faq","contact"].indexOf(location) !==-1)  {
                    thisref._popup_default_loadcontent("/"+location)
                }
                if(window.location.href.indexOf("/help") !==-1){
                    let afterurl=window.location.href.split("/help")[1] || "";
                    thisref._popup_default_loadcontent("/help"+afterurl);
                }
            }

            //footer links open popup
            $(".footer-links a.openinpopup").click(function (e) {
                e.preventDefault();
                let afterurl=$(this).attr("href");
                if(afterurl=="/help"){afterurl="/help/whatis?g=topup";}
                thisref._popup_default_loadcontent(afterurl);
            });

            //over18 links open popup
            $("#over18 .text a").click(function (e) {
                e.preventDefault();
                let afterurl=$(this).attr("href");
                thisref._popup_default_loadcontent(afterurl);
            });
        });
    }

    /**************************************************************************/

    /**
     * Happy hour ellenőrzés ciklikusan (Ha van új Happy hour, reload)
     */
    public hhour_timeout=-1;
    public tright_timeout=-1;
    public thepromo=null;
    private checkhappy=false;
    _checkHappyHourPromo(opentopup=false, calledfromroomlist=false) {
        if(this.checkhappy){return;}
        // @ts-ignore
        if((typeof roomListNG !== 'undefined' && roomListNG.roomlistisloading) && !calledfromroomlist){
            if(opentopup){
                window["chatClient"].app.view.topupPanel.show();
                this.checkhappy=false;
                return;
            }
        }

        let _thisObj = this;

        _thisObj.checkhappy=true;
        let timout=setTimeout(function () { _thisObj.checkhappy=false;},5000);
        try {
            return new Promise<void>((resolve, reject) => {
                $.ajax({
                    url: '/ajax/api/getPromos',
                    type: 'GET',
                    dataType: 'json',
                    data: {},
                    complete: function(data) {
                        //setTimeout(function () {
                            if(opentopup){window["chatClient"].app.view.topupPanel.show(); console.log("TEST OPEN");}
                            //},150);//A set timout kell, hogy később mutatódjon, minthogy a promo object elkészül, máskülönben bugosan behozza a first promo bankkártyás oldalt
                        _thisObj.checkhappy=false;
                        clearTimeout(timout);
                    },error(jqXHR: JQueryXHR, textStatus: string, errorThrown: string): any {
                        reject();
                    }
                }).done((responseJSON) => {
                    let addgraphics=false;
                    // @ts-ignore
                    if (responseJSON.result === true && (securionPayHandler.promo==null ||  _thisObj.hhour_timeout==-1 || (securionPayHandler.promo!=null && securionPayHandler.promo.promo==null ))) {//alert(_thisObj.hhour_timeout+" "+ securionPayHandler.promo);
                        try{
                            addgraphics=true;
                            // @ts-ignore
                            if((securionPayHandler.promo==null || (securionPayHandler.promo!=null && securionPayHandler.promo.promo==null ) )){
                                // @ts-ignore
                                try{securionPayHandler.promo.clearPromo();}catch (e) {}
                                // @ts-ignore
                                try{_thisObj.thepromo = new Sxc.SecurionPay.ExtraCreditPromo("echh", responseJSON.extraCredit.priceTable, responseJSON.extraCredit.start * 1000, responseJSON.extraCredit.end * 1000, responseJSON.extraCredit.scriptParams);
                                }catch (e) {console.error(e)}
                                if(!$(".sxcc-topup-panel").is(":visible")) {
                                    setTimeout(function () {
                                        // @ts-ignore
                                        securionPayHandler.promo.setExtraCreditPromo(_thisObj.thepromo);
                                    }, 90);//A set timout kell bug miatt
                                }
                            }
                            // @ts-ignore
                            //if(typeof roomListNG !== 'undefined'){roomListNG._loadRoomList();}
                        }catch (e) { console.error(e) }

                        //auto remove after end
                        if(responseJSON.extraCredit.end>0){
                            try{clearTimeout(_thisObj.hhour_timeout);}catch(ex){}
                            _thisObj.hhour_timeout=setTimeout(() => {
                                try{clearTimeout(_thisObj.hhour_timeout);}catch(ex){}
                                _thisObj.hhour_timeout=-1;
                                // @ts-ignore
                                try{securionPayHandler.promo.clearPromo();}catch (e) {}
                                if($('.happy-hour-promo').length>0){
                                    $('.happy-hour-promo').remove();//_thisObj._loadRoomList();
                                    // @ts-ignore
                                    if(typeof roomListNG !== 'undefined'){roomListNG._addlastrooms_if_required(true);}
                                }
                            },(responseJSON.extraCredit.end-Math.ceil(new Date().getTime()/1000))*1000);
                        }
                    }
                    if(responseJSON.result === false){
                        try{clearTimeout(_thisObj.hhour_timeout);}catch(ex){}
                        _thisObj.hhour_timeout=-1;
                        // @ts-ignore
                        try{securionPayHandler.promo.clearPromo();}catch (e) {}
                        // @ts-ignore
                        if($('.happy-hour-promo').length>0){
                            $('.happy-hour-promo').remove();//_thisObj._loadRoomList();
                            // @ts-ignore
                            if(typeof roomListNG !== 'undefined'){roomListNG._addlastrooms_if_required(true);}
                        }
                    }

                    //Topright
                    if (responseJSON.result_topright === true && _thisObj.tright_timeout==-1) {
                        addgraphics=true;
                        //auto remove after end
                        if(responseJSON.extraCredit.end>0){
                            try{clearTimeout(_thisObj.tright_timeout);}catch(ex){}
                            _thisObj.tright_timeout=setTimeout(() => {
                                // @ts-ignore
                                _thisObj.tright_timeout=-1;
                                if($('.top-right-promo').length>0){
                                    $('.top-right-promo').remove();//_thisObj._loadRoomList();
                                    // @ts-ignore
                                    if(typeof roomListNG !== 'undefined'){roomListNG._addlastrooms_if_required(true);}
                                }
                            },(responseJSON.extraCredit.end-Math.ceil(new Date().getTime()/1000))*1000);
                        }
                    }
                    if(responseJSON.result_topright === false){
                        _thisObj.tright_timeout=-1;
                        // @ts-ignore
                        if($('.top-right-promo').length>0){
                            $('.top-right-promo').remove();//_thisObj._loadRoomList();
                            // @ts-ignore
                            if(typeof roomListNG !== 'undefined'){roomListNG._addlastrooms_if_required(true);}
                        }
                    }

                    //Add graphics
                    if (addgraphics) {
                        // @ts-ignore
                        roomListNG._renderHappyHourPromo(responseJSON==null?"notnull":responseJSON);
                    }
                    resolve();
                });
            });

        } catch(ex) { console.error(ex); }
    }

    /**************************************************************************/

    /**
     * Balance ellenőrzése. Ha kevesebb, mint 1000 villogó piros pötty
     */
    private observer_fortopup=null;
    _checkTopupBalance(onlyobserver=false) {
        let _thisObj = this;
        if(!onlyobserver){
            this.getCreditNumber().then(function(creditNumber) {
                $('.credit-indicator').removeClass( 'red-topup').removeClass( 'green-topup');
                $('.credit-indicator').addClass( ((creditNumber < 1000) ? 'red-topup' : 'green-topup') );
                $("#creditval").text(String(creditNumber));

                //first topup promó ektüntetése topup után ha szükséges
                if($(".sxcc-stream-promo").is(":visible") && !$('.sxcc-topup-panel').is(":visible") && _thisObj.topups>0){
                    $(".sxcc-stream-promo").remove();
                }
            });
        }

        //Kreditek mutatása a popupban is
        if($('.sxcc-topup-panel').length>0 && $(".sxcc-topup-panel[data-observed='true']").length==0){
            this.observer_fortopup = new MutationObserver(function(mutations) {
                if($(".sxcc-topup-panel > .credit").length==0){
                    $("#creditcont").clone().insertAfter(".sxcc-topup-panel .sxcct-picker").show();
                }
                _thisObj._checkTopupBalance();
                _thisObj._checkHappyHourPromo();
            });
            this.observer_fortopup.observe($('.sxcc-topup-panel')[0], {  attributes: true   });
            $('.sxcc-topup-panel').attr("data-observed","true");
        }
    }

    /**
     * Popupba ajax tartalom betöltés
     */
    _popup_default_loadcontent(url) {
        let thisref=this;

        //Cím beállítása
        let title= $(".footer-links a[href*='"+url+"']").text();
        if(url.indexOf("/help") !==-1){title= $(".footer-links a[href*='/help']").text();}
        if(title!=""){
            $('#defaultpop .window .header').text(title);
        }

        $('#defaultpop .window').attr("data-url",url);

        $('#defaultpop').removeClass('hidden');
        $("#defaultpopcontent").css("visibility","hidden");
        window.history.replaceState("", "", url);
        if(["/billingsupport","/contact","/faq"].indexOf(url) !==-1 || url.indexOf("/help") !==-1){//old design get content
            let ajaxfaq="1";
            if(url.indexOf("/help") !==-1){ajaxfaq="0";}
            $.get( url, {ajax: "1",ajaxfaq:ajaxfaq }, function( data ) {
                $('#defaultpopcontent').animate({scrollTop:0}, 1);
                data=data.replace('id="longtext"','');
                let data2=$(data).find(".scrollPanel").next();
                $("#defaultpopcontent").html($(data2)[0].outerHTML);
                $("#defaultpopcontent a").each(function () {
                   if($(this).attr("href").indexOf("http")===-1){
                       $(this).click(function (e) {
                           e.preventDefault();
                           thisref.hidePopup();
                           thisref._popup_default_loadcontent($(this).attr("href"))
                       });
                   }
                });
                $("#defaultpopcontent").css("visibility","visible");
                if(["/contact"].indexOf(url) !==-1 ){
                    thisref.contact_form_handler();
                }
            });

        }else{//default longtext
            $.get( url, { ajax: "1"}, function( data ) {
                $('#defaultpopcontent').animate({scrollTop:0}, 1);
                $("#defaultpopcontent").html(data);
                $("#defaultpopcontent").css("visibility","visible");
            });
        }
        $('#defaultpopcontent').scrollbar();
    }

    /**
     * Pupup típusú kapcsolati form handler
     */
    contact_form_handler() {
        let thisref=this;
        $(".supportform_input input[type='image']").clone().attr("type","submit").insertAfter(".supportform_input input[type='image']");
        $(".supportform_input input[type='image']").hide();
        $(".supportform_input input[type='image']").after('<script src="/design/default/support.js"></script>');
        $("#defaultpopcontent form").submit(function (e) {
            e.preventDefault();
            var data = $(this).serialize()+"&ajax2=1&g-recaptcha-response="+$("[name='g-recaptcha-response']").val();
            $.post( "/contactajax?ajax=1", data, function( data ) {
                let data2=$(data).find(".scrollPanel").next();
                $("#defaultpopcontent").html($(data2)[0].outerHTML);
                $("#defaultpopcontent a").each(function () {
                    if($(this).attr("href").indexOf("http")===-1){
                        $(this).click(function (e) {
                            e.preventDefault();
                            thisref.hidePopup();
                            thisref._popup_default_loadcontent($(this).attr("href"));
                        });
                    }
                });
                $("#defaultpopcontent").css("visibility","visible");
                thisref.contact_form_handler();
            });
            return false;
        });
    }

    /**
     * Popup bezárés
     */
    _popup_close() {
        $('#defaultpop,#successpop').addClass('hidden');
        if(window.location.href.indexOf("/live") === -1){window.history.replaceState("", "", "/live");}
    }

    /**************************************************************************/

    getLanguageJSON() : Promise<void> {
        return this._callGet('/ajax/api/language', {})
            .then((responseJSON) => { this.translateJSON  = responseJSON; });
    }

    getTranslate(keyName : string) {
        if(keyName in this.translateJSON) {
            return this.translateJSON[keyName];
        }

        return '%%' + keyName + '%%';
    }

    /**************************************************************************/

    /**
     * Poppup megjelenítése
     */
    showPopup(idName : string) : void {
        this.hidePopup();
        $('#'+idName).removeClass('hidden');
        /*if(idName=="loginpop"){
            setTimeout(function () { $('#signin_name').focus();  },200);
        }else if(idName=="regpop"){
            setTimeout(function () { $('#signup_name').focus();  },200);
        }else if(idName=="forgotpop"){
            setTimeout(function () { $('#reminder_email').focus();  },200);
        }*/
    }

    /**
     * Popup eltüntetése
     */
    hidePopup() : void {
        $('.popup:visible').addClass('hidden');
    }

    /**
     * Hibaüzenet megjelenítése a popup űrlappon
     */
    showPopupError(fieldId : string, errorMsg : boolean|string) {
        $('#'+fieldId).addClass('sxcf-has-error');

        let errorDivElement = $('<div>').addClass('error-msg').addClass('required').html(<string>errorMsg);
        let containerDivElement = $('<div>').addClass('errors').addClass('errors-bottom-left').addClass('visible').append(errorDivElement);

        $('#'+fieldId).parent().append(containerDivElement);
    }

    /**
     * Hibaüzenetek törlése a popup űrlapról
     */
    clearPopupError() {
        $('.sxcf-has-error').each((itemIndex, itemObj) => { $(itemObj).removeClass('sxcf-has-error'); });
        $('.errors').remove();
    }

    /**
     * Beállítások menü új elrendezés kezelője
     */
    _settings_menuHandler() {
        $(document).ready(function () {
            $("#header").find(".userMenu .settings").on("click", "a", (e) =>
            {
                var $link = $(e.currentTarget);
                var url = $link.attr("href");
                if (url.substr(0,11) === "/myaccount/") {
                    $("#frame_myaccount:not(.faqpop) .content-wrapper").insertAfter($("#frame_myaccount .sidebar li[data-name*='"+url.replace("/myaccount/","")+"']"));
                }
                $("#frame_myaccount .sidebar:not(#faq) li").click(function () {
                    $("#frame_myaccount .sidebar:not(#faq) .content-wrapper").insertAfter($(this));
                });
            });
        });
    }

    /**************************************************************************/

    /**
     * Felbindeli a short kódokat az eseményekkel
     */
    _bindShortKey() : void {
        let _thisObj = this;

        $(document).keyup(function(e) {
             if (e.keyCode == 27  && !$("#defaultpop").is(":visible")) { // escape
                 console.log("triggeresc");
                 setTimeout(function () { _thisObj.hidePopup();},50);
             }
            else if (e.keyCode === 27 && $("#defaultpop").is(":visible")){
                // @ts-ignore
                 setTimeout(function () { _thisObj._popup_close();},50);
            }
             if (e.keyCode == 13) { // enter
                 if($('.popup').not('.hidden').length == 0) { return; }

                 $('.popup').not('.hidden').find('button').trigger('click');
             }
        });

        $(document).ready(function () {
            //design fix
            $("input,textarea").keyup(function () {
                if($(this).val()!=""){
                    $(this).addClass("sxcf-has-content");
                }else{
                    $(this).removeClass("sxcf-has-content");
                }
            });
        });
    }

    /**
     * Felbindeli az eseményeket a dom fára
     */
    _bindDOMEvent() : void {
        $( document ).on('click', '.favorite', (domObj) => {
            this.favoriteHandler( $(domObj.target).data('perfid') );
        });
    }

    /**************************************************************************/

    private signUpCalling=false
    signupHandler() : void {
        let thisref=this;
        if(thisref.signUpCalling){return;}
        thisref.signUpCalling=true;
        this.clearPopupError();  // Hibaüzenetek törlése az űrlapról
        $("#regbutton").prop("disabled","true");

        $("#wait").show();
        $('#wait').css("position","fixed");
        this._callPost('/', {
            action: 'join',
            userid: $('#signup_name').val(),
            email: $('#signup_email').val(),
            passwd: $('#signup_pass1').val(),
            passwd2: $('#signup_pass2').val(),
            token: $('#recaptchatoken_reg').val(),
            ajax: 1
        },function () {
            $("#wait").hide();
            $('#wait').css("position","absolute");
        }).then((responseJson : SexChatResponse) => {
            thisref.signUpCalling=false;
            if(responseJson.error === false) {
                this.hidePopup();
                this.showPopup("successpop");
            } else {
                $("#regbutton").removeAttr("disabled");
                if((<string>responseJson.error).indexOf("pass")!==-1){
                    $('#signup_pass1').focus();
                    this.showPopupError('signup_pass1', this.getTranslate(<string>responseJson.error));
                }else if((<string>responseJson.error).indexOf("email")!==-1){
                    $('#signup_email').focus();
                    this.showPopupError('signup_email', this.getTranslate(<string>responseJson.error));
                }else{
                    $('#signup_name').focus();
                    this.showPopupError('signup_name', this.getTranslate(<string>responseJson.error));
                }
                // @ts-ignore
                reCAPTCHA_execute();
            }
        });
    }

    private signinIsCalling=false
    signinHandler() : void {
        let thisref=this;
        if(thisref.signinIsCalling){return;}
        thisref.signinIsCalling=true;
        $("#signinbutton").prop("disabled","true");
        this.clearPopupError();  // Hibaüzenetek törlése az űrlapról
        this._callPost('/', {
            action: 'login',
            userid: $('#signin_name').val(),
            passwd: $('#signin_passwd').val(),
            token: $('#recaptchatoken').val(),
            rememberme: $('#loginPanelRememberme').is(":checked") ? "1" : "",
            ajax: 1
        }).then((responseJson : SexChatResponse) => {
            thisref.signinIsCalling=false;
            if(responseJson.error === false) {
                location.href = location.href.substr(0, location.href.indexOf('#')) || location.href ;
            } else {
                $("#signinbutton").removeAttr("disabled");
                this.showPopupError('signin_name', this.getTranslate(<string>responseJson.error));
                this.showPopupError('signin_passwd', this.getTranslate(<string>responseJson.error));
                $('#signin_name').focus();
                // @ts-ignore
                reCAPTCHA_execute();
            }
        });
    }

    logoutHandler() : void {
        this._callGet('/ajax/api/logout', {})
            .then(() => { location.href = location.href.substr(0, location.href.indexOf('#')) || location.href });
    }

    backToOldDesignHandler() : void {
        window["cookie"].erase("old_design");
        window["cookie"].create("old_design", "1");
        location.href ="/";
    }

    goToNewdDesignHandler() : void {
        window["cookie"].erase("old_design");
        window["cookie"].create("old_design", "0");
        location.href ="/";
    }

    reminderHandler() : void {
        this.clearPopupError();  // Hibaüzenetek törlése az űrlapról

        this._callPost('/', {
            action: 'reminder',
            email: $('#reminder_email').val(),
            ajax: 1
        }).then((responseJson : SexChatResponse) => {
            if(responseJson.error === false) {
                this.hidePopup();
                this.showPopup('forgotsentpop');
            } else {
                this.showPopupError('reminder_email', this.getTranslate(<string>responseJson.error));
                $('#reminder_email').focus();
            }
        });
    }

    favoriteHandler(performerId) {
        let isFavoritedRoom = $('.room-item-'+performerId).find('.favorite').hasClass('on');

        this._callPost('/ajax-favourites', {
            command: ((isFavoritedRoom) ? 'del' : 'add'),
            perfid: performerId
        }).then(() => {
            if(isFavoritedRoom) {
                $('.room-item-'+performerId).find('.favorite').removeClass('on');
            } else {
                $('.room-item-'+performerId).find('.favorite').addClass('on');
            }
        });
    }

    /**************************************************************************/

    private current_credits=-1;
    private topups=-1;
    public reg_date=new Date()+"";
    getCreditNumber() {
        return new Promise((resolve, reject) => {
            this._callGet('/ajax/credit/getcredits', {"topups":"1"//,"reg_date":"1"
            }).then((responseJSON : CreditResponse) => {
                if(responseJSON.result == 'success') {
                    // @ts-ignore
                    if ("wheelPromo" in responseJSON && responseJSON.wheelPromo!=null) {
                        console.log("[creditDisplayHandler][update]", "Calling wheel promo handler");
                        // @ts-ignore
                        if ("wheelPromoHandler" in window) window.wheelPromoHandler.update(responseJSON.wheelPromo);
                    }

                    //Zero Popup funcion
                    this.current_credits=responseJSON.credit;
                    this.topups=responseJSON.topups;
                    //this.reg_date=responseJSON.reg_date;
                    this.showZeroTopupPopupIfNecessary();

                    resolve(responseJSON.credit);
                } else {
                    resolve(0);
                }
            });
        });
    }

    /**************************************************************************/

    _callGet(url : string, data : {[key : string] : any}) {
        return this._sendAjax(url, data, "GET");
    }

    _callPost(url : string, data : {[key : string] : any},complete=null) {
        return this._sendAjax(url, data, "POST",complete);
    }

    _sendAjax(url : string, data : {[key : string] : any}, method : "GET"|"POST" = "GET",complete=null) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                type: method,
                data: data,
                crossDomain: true,
                dataType: "text",
                xhrFields: { withCredentials: true },
                complete:complete==null?function () {}:complete,
                success: (response : string) => {
                    try {
                        resolve( $.parseJSON(response) );
                    } catch (e) {
                        reject("Failed to parse JSON from calling '" + e);
                    }
                },
                error: (...args : any[]) => {
                    console.error("WebAPI2", "Failed to call WebAPI2", ...args);

                    reject();
                }
            });
        });
    }
}

var babesHandler = null;
